import http from '@/utils'
import api from '@/api/apiUrls'

export const feedback = {
  fetchFeedback,
  sendFeedback,
  updateFeedback,
  getAuthenticationNumber,
  retrievePassword
}

function fetchFeedback(_surveyId) {
  return http.get(api.FEEDBACK_GET.replace('{survey_id}', _surveyId))
}

function sendFeedback(_surveyId, _postParameters) {
  return http.post(api.FEEDBACK_SEND.replace('{survey_id}', _surveyId), _postParameters)
}

function updateFeedback(_surveyId, responseId, _postParameters) {
  return http.post(api.FEEDBACK_UPDATE.replace('{survey_id}', _surveyId).replace('{response_id}', responseId), _postParameters)
}

function getAuthenticationNumber(_postParameters) {
  return http.post(api.REGISTER_SOFTWARE, _postParameters)
}

function retrievePassword(_postParameters) {
  return http.post(api.RETRIEVE_PASSWORD, _postParameters)
}
